/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Debt_Fill_Col_OwingInputs */

const vi_lot_debt_fill_col_owing = /** @type {(inputs: Lot_Debt_Fill_Col_OwingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang nợ`)
};

/**

* @param {Lot_Debt_Fill_Col_OwingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_col_owing = /** @type {((inputs?: Lot_Debt_Fill_Col_OwingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_Col_OwingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_col_owing(inputs)
});